// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"naa-z","colorTextValue":"oaa-z","swatches":"paa-z","collapseLink":"qaa-z","isCollapsed":"raa-z","dropdown":"saa-z","disabled":"taa-z"};